import React from 'react';
import { IMAGE_HOST } from 'src/utils/constants';
import { ts } from 'src/utils/translate';

export const TableProductCategoryIcons = React.memo(function WrappedPureTable(props: any) {
  const {
    icons
  } = props;

  const isSvgIcon = (icon: string) => {
    return icon && icon.indexOf("<svg xmlns") === 0;
  };

  const isSvgFromUrl = (icon: string) => {
    return icon && icon.substr(icon.length - 4) === ".svg";
  };

  const isProtocolInUrl = (icon: string) => {
    return typeof icon === "string" && icon.indexOf("http") === 0;
  };

  return (
      <>
        {(icons && icons.length) ? (
            <table className={`docu-table lightershadow quote-datatable table table-bordered table-hover order-column dataTable`} style={{width: '100%'}} >
              <thead>
              <tr>
                <th style={{width: 100}}></th>
                <th style={{ textAlign : 'left', width: 'auto' }}>{ ts('quote_thead_category_name', 'Category Name') }</th>
                <th style={{width: 100}}> { ts('quote_thead_count', 'Quantity')} </th>
              </tr>
              </thead>
              <tbody>
              {icons.map((icon: any, index: number) => (
                  <tr className={`product-row ${index % 2 ? "even" : "odd"}`}>
                    <td
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          alignContent: 'center',
                          height: '100%',
                        }}
                    >
                      <div style = {{
                        height: "25px",
                        minHeight: "25px",
                        maxHeight: "25px",
                        width: "25px",
                        minWidth: "25px",
                        maxWidth: "25px",
                        marginRight: "15px",
                        display: "inline-block",
                      }}
                           >

                        {icon && isSvgIcon(icon.icon) && (() => {
                            const updatedSvg = icon.icon.replace( '<svg ', '<svg style="height: 100%; width: 100%;"' )
                            return (
                                <div
                                    style={{ height: "100%", width: "100%" }}
                                    dangerouslySetInnerHTML={{ __html: updatedSvg }}
                                />
                            );
                        })()}
                        {icon && isSvgFromUrl(icon.icon) && (
                            <div
                                style = {{
                                  height: "25px",
                                  minHeight: "25px",
                                  maxHeight: "25px",
                                  width: "25px",
                                  minWidth: "25px",
                                  maxWidth: "25px",
                                  display: "inline-block",
                                }}>
                              <img
                                  src={
                                    isProtocolInUrl(icon.icon) ? icon.icon : `${IMAGE_HOST}${icon.icon}`
                                  }
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                    aspectRatio : "1",
                                  }}
                              />
                            </div>
                        )}
                        {icon && !isSvgIcon(icon.icon) && !isSvgFromUrl(icon.icon) && (
                            <img src={
                              isProtocolInUrl(icon.icon) ? icon.icon : `${IMAGE_HOST}${icon.icon}`
                            }
                                 style={{
                                   height: "100%",
                                   width: "100%",
                                   aspectRatio: "1",
                                 }}/>
                        )}


                      </div>
                    </td>
                    <td style={{textAlign: 'left'}}>{icon.category_name}</td>
                    <td>{icon.count}</td>
                  </tr>
              ))}

              </tbody>

            </table>
        ) : '' }
      </>
  );
});
